import React from 'react'
import SignUpPage from '../component/SignUpPage'

const Signup = () => {
  return (
    <>
      <SignUpPage/>
    </>
  )
}

export default Signup;